module.exports = __webpack_public_path__ + "static/media/dreamerhug-2.9bad9418.jpg";